(function () {
  'use strict';

  function initFundingBannerHeadline() {
    const headline = document.querySelector('.pdp-funding-banner__section-headline');
    if (!headline) return;

    const words = headline.textContent.trim().split(' ');
    headline.textContent = '';
    words.forEach(function (word, i) {
      if (i > 0) headline.appendChild(document.createTextNode(' '));
      const span = document.createElement('span');
      span.className = 'pdp-funding-banner__section-headline-word';
      span.textContent = word;
      headline.appendChild(span);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFundingBannerHeadline);
  } else {
    initFundingBannerHeadline();
  }
})();
